module.exports = "\r\n<div class=\"container\">\r\n\r\n<h4>\r\n  Contact dtuck43@gmail.com with any questions, comments or concerns.\r\n  <a routerLink=\"/\">Back to Main</a>\r\n</h4>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Dtuck/Desktop/projects/Javascript/metacritic-rebuild/src/app/reports/reports.component.html
// module id = ../../../../../src/app/reports/reports.component.html
// module chunks = main